// extracted by mini-css-extract-plugin
export default {"desktop":"desktop_Qp0mw","mobile":"mobile_Qyz16"};